<p-toast></p-toast>

<div *ngIf="accessDenied" class="p-m-3">Access Denied</div>

<div *ngIf="!accessDenied" class="p-m-3">
  <h3 class="mb-3 text-center">{{ clubName }}</h3>
  <div class="date-range mb-3">
    <input
      type="date"
      class="date-input"
      [ngModel]="startDate | date : 'yyyy-MM-dd'"
      (ngModelChange)="onStartDateChange($event)"
    />
    <span class="mx-2">-</span>
    <input
      type="date"
      class="date-input"
      [ngModel]="endDate | date : 'yyyy-MM-dd'"
      (ngModelChange)="onEndDateChange($event)"
    />
    <button
      pButton
      label="Load"
      icon="pi pi-search"
      (click)="loadReservations()"
      class="ml-2"
    ></button>
  </div>

  <div *ngIf="loading" class="text-center my-5">
    <span class="spinner-border" role="status"></span>
  </div>
  <p-table
    *ngIf="!loading"
    [value]="reservations"
    [paginator]="true"
    [rows]="10"
    sortMode="multiple"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="courtName">
          Court <p-sortIcon field="courtName"></p-sortIcon>
        </th>
        <th pSortableColumn="reservation_start_time">
          Start - End <p-sortIcon field="reservation_start_time"></p-sortIcon>
        </th>
        <th pSortableColumn="booking_user">
          Booker <p-sortIcon field="booking_user"></p-sortIcon>
        </th>
        <th>Booker's Phone Number</th>
        <th>Book Type</th>
        <th>Status</th>
        <th>Deny Reason</th>
        <th>Private</th>
        <th>Match Type</th>
        <th>Fixed Reservation</th>
        <th>Players</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-reservation>
      <tr [ngClass]="{'fixed-row': reservation.fixed_series_id}">
        <td>
          {{
            reservation.court?.name ||
              courtMap[reservation.court_id] ||
              reservation.court_id
          }}
        </td>
        <td>
          {{ reservation.reservation_start_time | date : "dd.MM.yyyy. HH:mm" }} -
          {{ reservation.reservation_end_time | date : "HH:mm" }}
        </td>
        <td [ngClass]="{'vip-name': isVip(getBookerId(reservation))}">{{ getUserName(reservation) }}</td>
        <td>
          <a [href]="'tel:' + getBookerPhone(reservation)">
            {{ getBookerPhone(reservation) }}
          </a>
        </td>
        <td>{{ getBookType(reservation) }}</td>
        <td>{{ reservation.reservation_status }}</td>
        <td>{{ reservation.deny_reason || "-" }}</td>
        <td>{{ reservation.is_private ? "Yes" : "No" }}</td>
        <td>{{ getMatchType(reservation) }}</td>
        <td>{{ reservation.fixed_series_id ? "Yes" : "No" }}</td>
        <td>
          <a href="" (click)="showPlayers(reservation); $event.preventDefault()"
            >View</a
          >
        </td>
        <td>
          <button
            *ngIf="reservation.reservation_status === 'Pending'"
            pButton
            icon="pi pi-check"
            class="p-button-text"
            (click)="approveReservation(reservation)"
          ></button>
          <button
            pButton
            icon="pi pi-times"
            class="p-button-text p-button-danger"
            [disabled]="reservation.reservation_status === 'Denied'"
            (click)="openDenyDialog(reservation)"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  header="Denial Reason"
  [(visible)]="denyDialogVisible"
  [modal]="true"
  [closable]="false"
>
  <textarea
    pInputTextarea
    [(ngModel)]="denyReason"
    rows="5"
    style="width: 100%"
  ></textarea>
  <p-footer>
    <button
      pButton
      label="Cancel"
      icon="pi pi-times"
      (click)="denyDialogVisible = false"
      class="p-button-text"
    ></button>
    <button
      pButton
      label="Submit"
      icon="pi pi-check"
      (click)="submitDeny()"
      [disabled]="!denyReason"
    ></button>
  </p-footer>
</p-dialog>

<p-dialog header="Players" [(visible)]="playersDialogVisible" [modal]="true">
  <ul>
    <li *ngFor="let p of players" [ngClass]="{'vip-name': p.isVip}">
      {{ getPositionLabel(p.position) }}: {{ p.full_name }} ({{ p.id }})
    </li>
  </ul>
</p-dialog>
